<template>
  <div v-if="type === 'megamenu'" class="relative group">
    <button class="nav-button group">
      <Icon
        :name="icon"
        class="w-5 h-5 mr-3.5 group-hover:text-primary transition-colors"
      />
      <span class="font-medium">{{ text }}</span>
      <Icon
        name="heroicons:chevron-down"
        class="w-4 h-4 ml-3 group-hover:text-primary transition-colors transform group-hover:-rotate-180 duration-200"
      />
    </button>
    <div class="megamenu-panel">
      <div class="grid grid-cols-3 gap-8 p-5">
        <div v-for="section in items" :key="section.title" class="space-y-5">
          <h3
            class="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-3"
          >
            <div class="w-3 h-3 bg-purple-800 rounded-full"></div>
            {{ section.title }}
          </h3>
          <ul class="space-y-3">
            <li v-for="item in section.items" :key="item.text">
              <nuxt-link :to="item.to" class="nav-link group">
                <Icon
                  v-if="item.icon"
                  :name="item.icon"
                  class="w-4 h-4 mr-3.5 text-gray-400 group-hover:text-primary transition-colors"
                />
                <span
                  class="group-hover:translate-x-0.5 transition-transform"
                  >{{ item.text }}</span
                >
              </nuxt-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div v-else-if="type === 'dropdown'" class="relative group">
    <button class="nav-button group">
      <Icon
        :name="icon"
        class="w-5 h-5 mr-3.5 group-hover:text-primary transition-colors"
      />
      <span class="font-medium">{{ text }}</span>
      <Icon
        name="heroicons:chevron-down"
        class="w-4 h-4 ml-3 group-hover:text-primary transition-colors transform group-hover:-rotate-180 duration-200"
      />
    </button>
    <div class="dropdown-panel">
      <ul class="py-3">
        <li v-for="item in items" :key="item.text">
          <nuxt-link :to="item.to" class="nav-link group">
            <Icon
              v-if="item.icon"
              :name="item.icon"
              class="w-4 h-4 mr-3.5 text-gray-400 group-hover:text-primary transition-colors"
            />
            <span class="group-hover:translate-x-0.5 transition-transform">{{
              item.text
            }}</span>
          </nuxt-link>
        </li>
      </ul>
    </div>
  </div>

  <nuxt-link v-else :to="to" class="nav-button group">
    <Icon
      :name="icon"
      class="w-5 h-5 mr-3.5 group-hover:text-primary transition-colors"
    />
    <span
      class="font-medium group-hover:translate-x-0.5 transition-transform"
      >{{ text }}</span
    >
  </nuxt-link>
</template>

<style scoped>
.nav-button {
  @apply px-5 py-3 text-sm font-medium transition-all duration-200 inline-flex items-center text-gray-700 hover:text-primary dark:text-gray-200 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50 relative;
}

.nav-link {
  @apply flex items-center text-sm text-gray-600 hover:text-primary dark:text-gray-300 px-5 py-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-all duration-200 relative;
}

.megamenu-panel {
  @apply absolute top-full left-0 w-screen max-w-screen-lg bg-white dark:bg-gray-900 shadow-xl rounded-xl mt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 border border-gray-200/50 dark:border-gray-700/50 z-[999] transform origin-top scale-95 group-hover:scale-100;
}

.dropdown-panel {
  @apply absolute z-[999] top-full left-0 w-72 bg-white dark:bg-gray-900 shadow-xl rounded-xl mt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 border border-gray-200/50 dark:border-gray-700/50 transform origin-top scale-95 group-hover:scale-100;
}
</style>

<script setup lang="ts">
defineProps<{
  type?: "megamenu" | "dropdown";
  icon: string;
  text: string;
  to?: string;
  items?: any[];
}>();
</script>
